module.exports = __webpack_public_path__ + "static/media/defaultdp.28604c26.svg";